import { CircularProgress } from '@mui/material';
import useStyles from './style';

const PageLoading = () => {
  const classes = useStyles();

  return (
    <div className={classes.container} data-testid="private-page-loading">
      <CircularProgress color="primary" size="4rem" />
    </div>
  );
};

export default PageLoading;
